module.exports = __webpack_public_path__ + "static/media/fruits_0.4ef6acf6.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_0.csv
// module id = 672
// module chunks = 0